import React, { useState, useEffect } from 'react';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  HStack,
  Tag,
  TagLabel,
  TagCloseButton,
  Text,
  VStack,
  Flex,
  Button,
  Card,
  CardBody,
  Tooltip
} from '@chakra-ui/react';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import { BlueCheckApplication } from '../../../utils/types';

interface ConfigureCallBackUriProps {
  onUpdateUri: (callbackUri: string) => void;
  onUpdateOrigin: (origins: string[]) => void;
  handleFinish: () => void;
  handleBack: () => void;
  editedApp: BlueCheckApplication | null;
}

const isValidUrl = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

export const ConfigureCallBackUri: React.FC<ConfigureCallBackUriProps> = ({
  handleFinish,
  handleBack,
  onUpdateUri,
  onUpdateOrigin,
  editedApp,
}) => {
  const [callbackUri, setCallbackUri] = useState<string>(
    editedApp ? editedApp.callbackUri : ''
  );
  const [origins, setOrigins] = useState<string[]>(editedApp ? editedApp.origins : []);
  const [currentOrigin, setCurrentOrigin] = useState<string>('');
  const [uriError, setUriError] = useState<string | null>(null);
  const [originError, setOriginError] = useState<string | null>(null);

  const { width } = useWindowDimensions();

  useEffect(() => {
    onUpdateUri(callbackUri);
  }, [callbackUri]);

  useEffect(() => {
    onUpdateOrigin(origins);
  }, [origins]);


  const handleAddOrigin = () => {
    if (currentOrigin.trim() === '') {
      setOriginError('Origin cannot be empty.');
      return;
    }

    if (!isValidUrl(currentOrigin.trim())) {
      setOriginError('Invalid URL format.');
      return;
    }
    if (origins.includes(currentOrigin)) {
      setOriginError('Origin has been added.');
      return;
    }

    setOrigins([...origins, currentOrigin.trim()]);
    setCurrentOrigin('');
    setOriginError(null);
  };


  const handleRemoveOrigin = (originToRemove: string) => {
    setOrigins(origins.filter((origin) => origin !== originToRemove));
    setOriginError(null);
  };

  const handleFinishClick = () => {
    // if (!callbackUri.trim()) {
    //   setUriError('Callback URI cannot be empty.');
    //   return;
    // }
  
    // if (!isValidUrl(callbackUri.trim())) {
    //   setUriError('Invalid Callback URI format.');
    //   return;
    // }
  
    if (origins.length === 0) {
      setOriginError('At least one origin must be added.');
      return;
    }
  
    setUriError(null);
    setOriginError(null);
    handleFinish();
  };
  

  return (
    <Card
      w={width > 1740 ? '1300px' : '95%'}
      variant="outline"
      mt={6}
      backgroundColor="#FFF"
      borderRadius="12px"
      h="fit-content"
    >
      <CardBody p={10}>
        {/* <FormControl>
          <FormLabel>
            Callback URI
            <Tooltip label="Ensure the endpoint has /callback if you want to store proof and sessionId in your backend">
              <Text as="span" fontSize="sm" color="gray.500" ml={2}>(For more info)</Text>
            </Tooltip>
          </FormLabel>
          <HStack>
            <Input
              value={callbackUri}
              onChange={(e) => setCallbackUri(e.target.value)}
              placeholder="Enter Callback URI and press Enter"
            />
          </HStack>
          {uriError && (
            <Text color="red.500" mt={2}>
              {uriError}
            </Text>
          )}
        </FormControl> */}

        <FormControl mt={'20px'}>
          <FormLabel>Origins
            <Tooltip label="Origins define which base URLs can access your app, enhancing security by preventing unauthorized access.">
              <Text as="span" fontSize="sm" color="gray.500" ml={2}>(For more info)</Text>
            </Tooltip>

          </FormLabel>
          <HStack>

            <Input
              value={currentOrigin}
              onChange={(e) => setCurrentOrigin(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleAddOrigin()}
              placeholder="Enter Origin and press Enter"
            />
            <Button onClick={handleAddOrigin} colorScheme="blue">
              Add
            </Button>
          </HStack>

          {originError && (
            <Text color="red.500" mt={2}>
              {originError}
            </Text>
          )}
          <HStack wrap="wrap" mt={2}>
            {origins.map((origin, index) => (
              <Tag
                key={index}
                size="lg"
                colorScheme="blue"
                borderRadius="full"
                variant="solid"
              >
                <TagLabel>{origin}</TagLabel>
                <TagCloseButton onClick={() => handleRemoveOrigin(origin)} />
              </Tag>
            ))}
          </HStack>
        </FormControl>

        <VStack className="stepper-bar" alignItems="space-between">
          <Flex alignItems="center" gap={3} justifyContent="space-between">
            <Button
              onClick={handleBack}
              className="stepper-back-button small-font"
              _hover={{
                transform: 'scale(1.05)',
              }}
            >
              Back
            </Button>
            <Flex alignItems="center" gap="17px">
              <Text color="gray.500" className="x-small-font">
                4/4
              </Text>
              <Button
                onClick={handleFinishClick}
                className="small-font stepper-next-button"
                fontFamily="inter"
                _hover={{
                  transform: 'scale(1.05)',
                }}
              >
                Finish
              </Button>
            </Flex>
          </Flex>
        </VStack>
      </CardBody>
    </Card>
  );
};
